<template>
  <ValidationProvider
    v-slot="{ errors }"
    :name="`field_${_uid}`"
    :rules="rules"
    :custom-messages="{
      required: $t('validation.namedFieldIsMandatory', {
        field: localize(this.item.label)
      })
    }"
    mode="eager"
  >
    <v-text-field
      v-model="fieldValue"
      outlined
      flat
      hide-details="auto"
      :label="fieldLabel"
      :name="fieldLabel"
      :error-messages="errors"
      :autocomplete="autofill"
    ></v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: false,
      default: ''
    },

    autofill: {
      type: String,
      required: false,
      default: 'off'
    }
  },

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    rules() {
      if (this.item.fieldValidationMode === 2) {
        return 'required';
      }

      return '';
    }
  },

  components: {
    ValidationProvider
  }
};
</script>
